<template>
  <table class="responsive-table">
    <thead>
      <tr>
        <th
          v-for="col in columns"
          :key="col.id"
          @click="emitSort(col)"
        >
          {{ col.display_label }}
          <template v-if="col.sortable">
            <font-awesome-icon
              :icon="['fas', 'sort']"
              class="icon alt"
            />
            <span
              v-if="col.id == sortedColumn"
              :class="sortedAsc ? 'active-up' : 'active-down'"
            >
              <font-awesome-icon
                :icon="['fas', 'sort-down']"
                class="icon alt"
              />
              <font-awesome-icon
                :icon="['fas', 'sort-up']"
                class="icon alt"
              />
            </span>
          </template>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="row in appointments"
        :key="row.id"
      >
        <td>
          <router-link :to="`/student/${row.client.userId}`">
            {{ row.client.firstName }} {{ row.client.lastName }}
          </router-link>
          <label class="d-block d-md-none">
            Client:
          </label>
        </td>

        <td>
          {{ row.client.campus.name }}
          <label class="d-block d-md-none">
            School:
          </label>
        </td>

        <td>
          {{ row.when | withTimeZone | format('M/D/YYYY h:mmA (z)') }}
          <label class="d-block d-md-none">
            Date/Time:
          </label>
        </td>

        <td>
          <div class="outcome-type">
            <div v-if="row.status.id === 'Successful'" class="good" />
            <div v-else-if="row.status.id === 'Upcoming'" class="good" />
            <div v-else-if="row.status.id === 'InProgress'" class="good" />
            <div v-else-if="row.status.id === 'CounselorCanceled'" class="normal" />
            <div v-else-if="row.status.id === 'UserCanceled'" class="normal" />
            <div v-else-if="row.status.id === 'UserLateCanceled'" class="warn" />
            <div v-else-if="row.status.id === 'AdminCanceled'" class="normal" />
            <div v-else-if="row.status.id === 'CounselorNoShow'" class="bad" />
            <div v-else-if="row.status.id === 'UserNoShow'" class="warn" />
            <div v-else-if="row.status.id === 'BothNoShow'" class="bad" />
            <div v-else class="warn" />
          </div>
        </td>
        <td>
          {{ row.status.display }}
          <label class="d-block d-md-none">
            Status:
          </label>
        </td>
        <td class="action-row">
          <button v-if="row.status.id === 'Upcoming'"
                  v-b-tooltip.hover.top="'Delete'"
                  type="button"
                  class="btn btn-ghost first"
                  @click="emitCancel(row)"
                  @mouseover="update_now()"
          >
            <font-awesome-icon :icon="['fas', 'trash']" class="icon alt" />
          </button>
          <button v-if="row.status.id === 'Upcoming'"
                  v-b-tooltip.hover.top="'Reschedule'"
                  type="button"
                  class="btn btn-ghost"
                  @click="editAppointment(row)"
                  @mouseover="update_now()"
          >
            Reschedule
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</template>

<script>
import moment from 'moment';

export default {
  name: 'AdminAppointmentsTable',
  props: {
    appointments: {
      type: Array,
    },
    editAppointment:{
      type: Function,
    },
    viewZoomHistory: {
      type: Function,
    },

    // add sorting
    sortedAsc: {
      type: Boolean,
    },
    sortedColumn: {
      type: String,
    },
    onSort: {
      type: Function,
    },
  },
  data() {
    return {
      created_now: null,
      columns: [
        { id: 'client', display_label: 'Client' },
        { id: 'school', display_label: 'School' },
        { id: 'when', display_label: 'Date/Time' },
        { id: 'status-color', display_label: '' },
        { id: 'status-text', display_label: 'Status' },
        { id: 'actions', display_label: '' }
      ],
    };
  },
  created() {
    this.update_now()
  },
  methods:{
    update_now() {
      this.right_now = moment().toDate()
    },
    emitSort(column) {
      if (column.sortable) this.onSort(column.display_label);
    },
    emitCancel(row) {
      this.update_now();
      if (row.when >= this.right_now) this.$emit('cancel', row.id);
    }
  },
};
</script>

<style lang="scss" scoped>
.responsive-table {
  @include border-radius($border-radius);

  width: 100%;
  border: none;

  thead {
    background: none;
    color: white;

    th {
      position: relative;
      padding: 0.75rem;
      padding-right: $gutter;
      white-space: nowrap;
      border-bottom: 2px solid rgba(255, 255, 255, 0.25);
      cursor: pointer;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;

      i,
      svg {
        position: absolute;
        top: 17px;
        right: 10px;
      }

      .fa-sort {
        z-index: 1;
        opacity: 0.2;
      }

      span {
        .fa-sort-up {
          z-index: 2;
          opacity: 0;
        }

        .fa-sort-down {
          z-index: 3;
          opacity: 0;
        }

        &.active-down {
          .fa-sort-down {
            opacity: 1;
          }
        }

        &.active-up {
          .fa-sort-up {
            opacity: 1;
          }
        }
      }

      &:hover {
        .fa-sort {
          opacity: 0.3;
        }

        span {
          .fa-sort-down {
            opacity: 1;
          }

          &.active-down {
            .fa-sort-down {
              opacity: 1;
            }

            .fa-sort-up {
              opacity: 0;
            }
          }

          &.active-up {
            .fa-sort-up {
              opacity: 1;
            }

            .fa-sort-down {
              opacity: 0;
            }
          }
        }
      }
    }
  }

  tbody {
    tr {
      td {
        padding: 0.75rem;
        color: rgba(white, 0.87);
        border-top: 1px solid rgba(255, 255, 255, 0.25);

        a {
          color: darken($highlight-color, 5%);
        }
      }
    }
  }

  @media (max-width: $sm-max) {
    display: block;
    border: none;

    thead,
    tbody,
    th,
    td,
    tr {
      display: block;
    }

    tbody {
      tr {
        background: $dark-blue;

        td {
          padding: 0.75rem;
          text-align: right;
          border-bottom: none;
          border-top: 1px solid rgba(255, 255, 255, 0.25);

          &:last-of-type {
            border-bottom: none;
          }
        }
      }
    }

    thead tr {
      position: absolute;
      top: -9999px;
      left: -9999px;
    }

    tr {
      @include border-radius($border-radius);

      margin: 0 0 1rem 0;
      background: white;
    }

    td {
      position: relative;
      padding-left: 50%;
      border: none;
      border-bottom: $secondary-border;

      label {
        position: absolute;
        top: 12.5px;
        left: 15px;
        width: 45%;
        padding-right: 10px;
        font-weight: bold;
        white-space: nowrap;
        text-align: left;
      }
    }
      .btn-ghost {
        border-color: $primary-color;
        background: $primary-color;
        color: $btn-color;
        height: 45px;
        margin-bottom: 10px;

        &:hover,
        &:focus {
          border-color: darken($primary-color, 5%);
          background-color: darken($primary-color, 5%);
          color: $btn-color;
        }
      }
  }
  .action-row {
    text-align: right;

    .btn.first {
      margin-right: 5px;
    }
    @media (max-width: $md-max) {
      .btn.first {
        margin-right: 0;
        margin-bottom: .5rem;
        width: 100%;
      }
    }
  }
  .outcome-type  {
    .status-display {
      padding-bottom: 5px;
    }
    .bad {
      display: inline-block;
      border-radius: 5px;
      width: 5px;
      height: 25px;
      background-color: $red;
    }
    .warn {
      display: inline-block;
      border-radius: 5px;
      width: 5px;
      height: 25px;
      background-color: $yellow;
    }
    .normal {
      display: inline-block;
      border-radius: 5px;
      width: 5px;
      height: 25px;
      background-color: $light-blue;
    }
    .good {
      display: inline-block;
      border-radius: 5px;
      width: 5px;
      height: 25px;
      background-color: $approval-green;
    }
  }
}
</style>
